import { useUserStore } from "@/stores/user";
import type { MiddlewareContext } from "@/types";

// Redirect to terms and conditions page if authenticated but haven't accepted them yet
export const requiresTerms = ({ to, next, router }: MiddlewareContext) => {
  const store = useUserStore();

  // Terms page will only be shown if an account is already activated
  if (!store.acceptedTerms && !store.isActivationRequired) {
    /*
     * Set the redirect to the intended target unless they also need a shipping address.
     * In that case, don't redirect at all so that on submit, you get redirected there with the proper parameters.
     */
    const query = store.user?.prompt_for_shipping_address ? undefined : { redirect: to.fullPath };

    router.push({
      path: "/terms",
      query: query
    });
    return;
  }

  return next();
};
